import React, { useState } from 'react';
import classNames from 'classnames';
import * as data from '../../Lokesh_Profile.json'
import { SectionProps } from '../../utils/SectionProps';
import { FaFacebookF,FaGithubAlt,FaLinkedinIn,FaMediumM,FaFileAlt,FaInstagram } from "react-icons/fa";

const propTypes = {
  ...SectionProps.types
}
const about = data.about
// const about = [{
//     "shortname":"Lokesh",
//     "location":'Chennai, India',
//     "photoURL":"https://drive.google.com/uc?export=view&id=1ms7MDmA-owOd1QlZA6DG1baHBI0rFZnW",
//     "about":"Lokesh Kumar is a self taught Full Stack Web Developer with the experience of 2.5 years, always open to learn new stuff. Currently working as a Software Engineer at Social Survey.",
//     "phone":"+91-9566132637",
//     "resume":"https://drive.google.com/file/d/1-p-XGCUbnGwdeOAsLUWxxwuSFqjgOiHv/view?usp=sharing",
//     "email":"lokeshkumar824@gmail.com",
//     "github":"https://github.com/Lokesh824",
//     "linkedin":"https://www.linkedin.com/in/lokesh824/",
//     "medium":"https://medium.com/@lokeshkumar824",
//     "facebook":"",
//     "instagram":""
// }]
const defaultProps = {
  ...SectionProps.defaults
}


const Reachout = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  }   

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );



  return (
    <div class="container">
    <div class="row mb-5 justify-content-center">
      <div class="col-md-5 text-center">
        <div class="ftco-footer-widget mb-5">
            <h2 class="mb-3 reveal-from-bottom"  data-reveal-delay="200">Reach Out</h2> <br />
          <ul class="ftco-footer-social list-unstyled reveal-from-bottom"  data-reveal-delay="400">
              <li><a target="_blank" href={about[0].github}><span class="icon-github"><FaGithubAlt /></span></a></li>
              <li><a target="_blank" href={about[0].medium}><span class="icon-medium"><FaMediumM /></span></a></li>
              <li><a target="_blank" href={about[0].linkedin}><span class="icon-linkedin"><FaLinkedinIn /></span></a></li>
            <li><a target="_blank" href={about[0].facebook}><span class="icon-facebook"><FaFacebookF /></span></a></li>
            <li><a target="_blank" href={about[0].instagram}><span class="icon-instagram"><FaInstagram /></span></a></li>
          </ul>
        </div>
        <div class="ftco-footer-widget">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
        <p>
      </p></div>
    </div>
  </div>
  )
}

export default Reachout;